export const CANDIDATE =
  process.env.NODE_ENV === "development"
    ? "http://178.128.61.193:7094/#/"
    : "https://candidate-v3.career.support/#/";
export const SCHOOL =
  process.env.NODE_ENV === "development"
    ? "http://178.128.61.193:7093/"
    : "https://school-v3.career.support/";
export const COMPANY =
  process.env.NODE_ENV === "development"
    ? "http://178.128.61.193:7095/"
    : "https://company-v3.career.support/";
export const E_LEARNING =
  process.env.NODE_ENV === "development"
    ? "http://128.199.224.138:7100/"
    : "https://e-learning-v3.career.support/";

// export const CANDIDATE = "http://178.128.61.193:7094/#/";
// export const SCHOOL = "http://178.128.61.193:7093/";
// export const COMPANY = "http://178.128.61.193:7095/";
// export const E_LEARNING = "http://128.199.224.138:7100/";

// export const CANDIDATE = "https://candidate-v3.career.support/#/";
// export const SCHOOL = "https://school-v3.career.support/";
// export const COMPANY = "https://company-v3.career.support/";
// export const E_LEARNING = "https://e-learning-v3.career.support/";

export const CANDIDATE_LOGIN = `${CANDIDATE}signin`;
export const SCHOOL_LOGIN = `${SCHOOL}login`;

// export const SUBDOMAIN = "abc".toLowerCase();
// export const SUBDOMAIN = window.location.pathname.split("/")[1].toLowerCase();
export const SUBDOMAIN = window.location.host.split(".")[0].toLowerCase();
